import { useTranslation } from 'react-i18next';
import { PATH_ROUTES } from 'routes/path';
import { NavItem } from '../types';
import { Feature, isFeatureEnabled } from 'lib/feature-flags';

export default function useSidebar() {
  const { t } = useTranslation();

  const upperNav = () => {
    return [
      {
        name: t('dashboard'),
        icon: 'dashboard',
        href: PATH_ROUTES.DASHBOARD,
      },
      {
        name: t('face_scan_reports'),
        icon: 'face-scan',
        href: PATH_ROUTES.FACE_SCAN,
        size: 17,
        feature: 'FACE_SCAN',
      },
      {
        name: t('voice_scan'),
        icon: 'voice-scan',
        href: PATH_ROUTES.VOICE_SCAN,
        feature: 'VOICE_SCAN',
      },
      {
        name: t('personalised_ai_reports'),
        icon: 'ai-report',
        href: PATH_ROUTES.PERSONALISED_AI_REPORT,
        feature: 'AI_REPORT',
      },
      {
        name: t('interpret_lab_reports'),
        icon: 'interpret-report',
        href: PATH_ROUTES.INTERPRET_LAB_REPORT,
        feature: 'LAB_REPORT',
      },
      {
        name: t('symptom_checker'),
        icon: 'symptom-checker',
        href: PATH_ROUTES.SYMPTOM_CHECKER,
        feature: 'SYMPTOM_CHECKER',
      },
      {
        name: t('risk_checker'),
        icon: 'risk-analysis',
        href: PATH_ROUTES.RISK_ANALYSIS,
        size: 24,
        feature: 'RISK_CHECKER',
      },
      {
        name: t('help_desk'),
        icon: 'helpdesk',
        href: PATH_ROUTES.HELP_DESK,
        size: 18,
      },
    ]
      .filter((item) => !item.feature || isFeatureEnabled(item.feature as Feature))
      .map(({ feature, ...item }) => item) as NavItem[];
  };

  const lowerNav = (logout: () => void, onSettingClick: () => void) => {
    return [
      {
        name: t('profile'),
        icon: 'profile',
        href: PATH_ROUTES.PROFILE,
      },
      {
        name: t('settings'),
        icon: 'settings',
        onClick: onSettingClick,
      },
      {
        name: t('notification'),
        icon: 'bell',
        href: PATH_ROUTES.NOTIFICATION,
        size: 20,
      },
      {
        name: t('sign_out'),
        icon: 'logout',
        onClick: logout,
      },
    ] as NavItem[];
  };

  return { upperNav, lowerNav };
}
